import React from "react";
import type { BookingErrors, BookingFormState } from "./useBookingForm";
interface StepProps {
  form: BookingFormState;
  errors: BookingErrors;
  update: <K extends keyof BookingFormState>(key: K, value: BookingFormState[K]) => void;
}
type TextField = "name" | "phone" | "email";
const fields: {
  key: TextField;
  label: string;
  type: string;
  placeholder: string;
  optional?: boolean;
}[] = [{
  key: "name",
  label: "Nama lengkap",
  type: "text",
  placeholder: "Nadia Putri"
}, {
  key: "phone",
  label: "Nomor WhatsApp",
  type: "tel",
  placeholder: "0812 3456 7890"
}, {
  key: "email",
  label: "Email",
  type: "email",
  placeholder: "kamu@email.com",
  optional: true
}];
export function BookingContactStep({
  form,
  errors,
  update
}: StepProps) {
  return <div className="space-y-5" data-id="element-60" data-mp="2cqs5vw4g7h7g">
      {fields.map(f => <div key={f.key} data-id="element-61" data-mp="1p28zjm4ylei0">
          <label htmlFor={`booking-${f.key}`} className="text-sm font-semibold text-ink" data-id="element-62" data-mp="1p1g1d9k2fxbh">
            {f.label}
            {f.optional && <span className="ml-1 font-normal text-ink-muted" data-id="element-63" data-mp="3ru6loa6tqqqu">(opsional)</span>}
          </label>
          <input id={`booking-${f.key}`} type={f.type} value={form[f.key]} onChange={e => update(f.key, e.target.value)} placeholder={f.placeholder} aria-invalid={!!errors[f.key]} aria-describedby={errors[f.key] ? `booking-${f.key}-error` : undefined} className={`mt-2 w-full rounded-card border bg-white px-4 py-3 text-sm text-ink placeholder:text-ink-muted/60 focus:outline-none focus:ring-2 focus:ring-sage ${errors[f.key] ? "border-[#B5543A]" : "border-cream-line"}`} data-id="element-64" data-mp="3vvs5kfhs05aj" />
          {errors[f.key] && <p id={`booking-${f.key}-error`} className="mt-2 text-xs text-[#B5543A]" data-id="element-65" data-mp="3mw51flxnwlds">
              {errors[f.key]}
            </p>}
        </div>)}
      <div data-id="element-66" data-mp="124mh3wy30leo">
        <label htmlFor="booking-notes" className="text-sm font-semibold text-ink" data-id="element-67" data-mp="124d0gzyxfqln">
          Catatan <span className="font-normal text-ink-muted" data-id="element-68" data-mp="cgh5vbmz7r6p">(opsional)</span>
        </label>
        <textarea id="booking-notes" rows={3} value={form.notes} onChange={e => update("notes", e.target.value)} placeholder="Alergi, preferensi tempat duduk, atau hal lain yang perlu kami tahu" className="mt-2 w-full resize-none rounded-card border border-cream-line bg-white px-4 py-3 text-sm text-ink placeholder:text-ink-muted/60 focus:outline-none focus:ring-2 focus:ring-sage" data-id="element-69" data-mp="7hnze363x0g1" />
      </div>
      <p className="text-xs text-ink-muted" data-id="element-70" data-mp="3kydhuq18bnzv">Konfirmasi akan kami kirim lewat WhatsApp.</p>
    </div>;
}